class CustomIconWithText extends HTMLElement {
    constructor() {
      super();
      this.slides = $('custom-icon-with-text .iwt--wrapper');
      this.init();
    }
    init() {
      this.slides.slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 5,
        responsive: [
          {
            breakpoint: 728,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
        ],
        prevArrow: `<button class="slick-prev slick-arrow"><svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" fill="white"/>
        <path d="M27.6124 13L17 24.0029L27.6152 35L28.9972 33.5729L19.7669 24.0029L29 14.4329L27.6124 13Z" fill="#192940"/>
        <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" stroke="#DCE7EF"/>
        </svg></button>`,
        nextArrow: `<button class="slide-arrow next-arrow"><svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="47.5" y="47.5" width="47" height="47" rx="23.5" transform="rotate(180 47.5 47.5)" fill="white"/>
        <path d="M20.3876 35L31 23.9971L20.3848 13L19.0028 14.4271L28.2331 23.9971L19 33.5671L20.3876 35Z" fill="#192940"/>
        <rect x="47.5" y="47.5" width="47" height="47" rx="23.5" transform="rotate(180 47.5 47.5)" stroke="#DCE7EF"/>
        </svg></button>`
      });
    }
}

customElements.define('custom-icon-with-text', CustomIconWithText);